<template>
  <div>
    <p class="text-h6 text-md-h4 text-center pt-4">Наши курсы</p>
    <v-container class="pa-4 text-center">
      <v-row class="fill-height" align="center" justify="center">
        <v-col>
          <v-slide-group v-if="IS_DESKTOP" v-model="model" center-active>
            <v-slide-item
              v-for="(course, index) in courses"
              :key="index"
              v-slot="{ toggle }"
            >
              <div class="ma-2" @click="toggle">
                <CoursePreview :course="course" :index="index"> </CoursePreview>
              </div>
            </v-slide-item>
          </v-slide-group>
          <v-carousel
            v-if="IS_MOBILE"
            class="d-flex justify-center align-center"
            height="400"
            hide-delimiters
          >
            <v-carousel-item
              v-for="(course, index) in courses"
              :key="index"
              reverse-transition="fade-transition"
              transition="fade-transition"
            >
              <CoursePreview :course="course" :index="index"> </CoursePreview>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CoursePreview from "../components/CoursePreview";
import courses from "../../src/courses/courses";
export default {
  name: "Courses",
  components: { CoursePreview },
  data: () => ({
    courses: courses,
    model: null,
  }),
  computed: {
    ...mapGetters(["IS_MOBILE", "IS_DESKTOP"]),
  },
};
</script>

